import useGetApi from 'src/api/useGetApi';

export interface Contact {
  id: string;
  companyId?: string | null;
  contactOwnerId: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  title?: string | null;
  isPrimary: boolean;
  creatorId: string;
  metadata: object | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
}

export function useContacts(companyId: string | undefined, enabled = true) {
  return useGetApi<Contact[]>({
    endpoint: 'contacts',
    queryParameters: companyId ? { companyId } : undefined,
    options: {
      enabled: !!companyId && enabled,
    },
  });
}

export default useContacts;
